import { render, staticRenderFns } from "./SaleReportHeader.vue?vue&type=template&id=3716dc1d"
import script from "./SaleReportHeader.vue?vue&type=script&lang=js"
export * from "./SaleReportHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports